/* ══════════════════════════════════════════════════════
   Artmate Clock PDP JS v2
   Duvar Saati ürün sayfası — option1=Boyut, option2=Çerçeve
   Galeri artmate-pdp.js ile aynı (figure tabanlı)
   ══════════════════════════════════════════════════════ */

(function () {
  'use strict';

  const $  = sel => document.querySelector(sel);
  const $$ = sel => Array.from(document.querySelectorAll(sel));

  const variants = window.__amVariants || [];
  if (!variants.length) return;

  let selectedVariantId = variants[0].id;
  let selectedSize  = variants[0].option1;
  let selectedFrame = variants[0].option2;
  let qty = 1;

  /* Seçili varyantı bul */
  function findVariant(size, frame) {
    return variants.find(v => v.option1 === size && v.option2 === frame)
        || variants.find(v => v.option1 === size)
        || variants[0];
  }

  /* ── PARA FORMAT ── */
  function formatMoney(cents) {
    return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ',00₺';
  }

  /* ── DOM GÜNCELLE ── */
  function updateUI(variant) {
    if (!variant) return;
    selectedVariantId = variant.id;

    /* Fiyat */
    const priceEl = document.getElementById('am-price-now');
    const wasEl   = document.getElementById('am-price-was');
    const saveEl  = document.getElementById('am-price-save');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (wasEl && saveEl) {
      if (variant.compare_at_price > variant.price) {
        wasEl.textContent  = formatMoney(variant.compare_at_price);
        saveEl.textContent = formatMoney(variant.compare_at_price - variant.price) + ' TASARRUF';
        wasEl.style.display  = '';
        saveEl.style.display = '';
      } else {
        wasEl.style.display  = 'none';
        saveEl.style.display = 'none';
      }
    }

    /* Sticky fiyat */
    const sp = document.getElementById('am-sticky-price-now');
    const sw = document.getElementById('am-sticky-price-was');
    if (sp) sp.textContent = formatMoney(variant.price);
    if (sw) {
      if (variant.compare_at_price > variant.price) {
        sw.textContent   = formatMoney(variant.compare_at_price);
        sw.style.display = '';
      } else {
        sw.style.display = 'none';
      }
    }

    /* Sticky varyant label */
    const sv = document.getElementById('am-sticky-variant');
    if (sv) sv.textContent = variant.option1 + ' · ' + variant.option2;

    /* CTA durumu */
    const atcBtn    = document.getElementById('am-add-to-cart');
    const stickyAtc = document.getElementById('am-sticky-atc');
    const buyNow    = document.getElementById('am-buy-now');
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.innerHTML = variant.available
        ? '<svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 5.5h13l-1.3 9a2 2 0 01-2 1.7H6.8a2 2 0 01-2-1.7L3.5 5.5z"/><path d="M7 8V5a3 3 0 016 0v3"/></svg>Sepete Ekle'
        : 'Tükendi';
    }
    if (stickyAtc) stickyAtc.disabled = !variant.available;
    if (buyNow)    buyNow.disabled    = !variant.available;

    /* Kargo şeridi */
    const shipRibbon = document.querySelector('.am-ship-ribbon .am-ship-line span b');
    if (shipRibbon) {
      if (variant.price >= 100000) {
        shipRibbon.closest('span').innerHTML = '<b>Ücretsiz kargo</b> · Yurtiçi · 2–6 iş günü teslimat';
      }
    }

    /* Paket askı adedi */
    const askiQty = document.getElementById('am-pkg-aski-qty');
    if (askiQty) {
      askiQty.textContent = variant.option1 && variant.option1.includes('100') ? '2 adet' : '1 adet';
    }

    /* URL param */
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url.toString());

    /* Taksit — skeleton göster, PayTR section gerçek değerleri dolduracak */
    updateInstallments();

    /* PayTR section'ının dinlediği event */
    document.dispatchEvent(new CustomEvent('artmate:variant:changed', { detail: { variant: variant } }));

    /* Stok uyarısı */
    updateStockAlert(variant);

    /* Badge (indirim) */
    updateBadge(variant);
  }

  /* ══════════════════════════════════
     GALERİ — artmate-pdp.js ile aynı (figure tabanlı)
  ══════════════════════════════════ */
  function initGallery() {
    const strip     = document.getElementById('am-gallery-main');
    const thumbsWrap = document.getElementById('am-g-thumbs');
    const counter   = document.getElementById('am-g-counter');
    if (!strip) return;

    const figures   = Array.from(strip.querySelectorAll('figure'));
    const thumbBtns = thumbsWrap ? Array.from(thumbsWrap.querySelectorAll('button')) : [];
    let current = 0;

    function goTo(idx) {
      current = idx;
      const fig = figures[idx];
      if (fig) strip.scrollTo({ left: fig.offsetLeft, behavior: 'smooth' });
      figures.forEach((f, i) => f.classList.toggle('am-active', i === idx));
      thumbBtns.forEach((b, i) => b.classList.toggle('active', i === idx));
      if (counter) counter.textContent = (idx + 1) + ' / ' + figures.length;
    }

    thumbBtns.forEach((btn, i) => btn.addEventListener('click', () => goTo(i)));

    const prevBtn = document.getElementById('am-gallery-prev');
    const nextBtn = document.getElementById('am-gallery-next');
    if (prevBtn) prevBtn.addEventListener('click', () => goTo(Math.max(0, current - 1)));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(Math.min(figures.length - 1, current + 1)));

    /* Swipe */
    let touchStartX = 0;
    strip.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
    strip.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 50) goTo(dx < 0 ? Math.min(current + 1, figures.length - 1) : Math.max(current - 1, 0));
    }, { passive: true });

    /* Mouse drag */
    let mouseStartX = 0, mouseDragging = false;
    strip.addEventListener('mousedown', e => {
      mouseStartX = e.clientX; mouseDragging = true;
      strip.style.cursor = 'grabbing'; e.preventDefault();
    });
    window.addEventListener('mousemove', e => {
      if (!mouseDragging) return;
      strip.scrollLeft += (mouseStartX - e.clientX) * 0.4;
    });
    window.addEventListener('mouseup', e => {
      if (!mouseDragging) return;
      mouseDragging = false; strip.style.cursor = 'grab';
      const dx = e.clientX - mouseStartX;
      if (Math.abs(dx) > 40) goTo(dx < 0 ? Math.min(current + 1, figures.length - 1) : Math.max(current - 1, 0));
    });
    strip.style.cursor = 'grab';

    strip.addEventListener('scroll', () => {
      const idx = Math.round(strip.scrollLeft / strip.offsetWidth);
      if (idx !== current) {
        current = idx;
        thumbBtns.forEach((b, i) => b.classList.toggle('active', i === idx));
        if (counter) counter.textContent = (idx + 1) + ' / ' + figures.length;
      }
    }, { passive: true });

    goTo(0);
  }

  function switchGalleryToImage(imgId) {
    const strip = document.getElementById('am-gallery-main');
    if (!strip) return;
    const figures = Array.from(strip.querySelectorAll('figure'));
    const idx = figures.findIndex(f => f.dataset.imageId == imgId || f.dataset.imgId == imgId);
    if (idx >= 0) {
      const thumbsWrap = document.getElementById('am-g-thumbs');
      const thumbBtns = thumbsWrap ? Array.from(thumbsWrap.querySelectorAll('button')) : [];
      if (thumbBtns[idx]) {
        thumbBtns[idx].click();
      } else {
        figures.forEach((f, i) => f.classList.toggle('am-active', i === idx));
        strip.scrollTo({ left: figures[idx].offsetLeft, behavior: 'smooth' });
      }
    }
  }

  /* ── ÇERÇEVE SWATCHLARI (option2) ── */
  function initFrameSwatches() {
    $$('.am-frame-swatch').forEach(btn => {
      btn.addEventListener('click', () => {
        $$('.am-frame-swatch').forEach(b => b.classList.remove('am-selected'));
        btn.classList.add('am-selected');
        selectedFrame = btn.dataset.option2;
        const frameVal = document.getElementById('am-frame-val');
        if (frameVal) frameVal.textContent = selectedFrame;

        const variant = findVariant(selectedSize, selectedFrame);
        updateUI(variant);

        /* Görsel değiştir */
        const imgId = btn.dataset.imgId;
        if (imgId) switchGalleryToImage(imgId);
      });
    });
  }

  /* ── BOYUT TİLELERI (option1) ── */
  function initSizeTiles() {
    $$('.am-clock-tile').forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        $$('.am-clock-tile').forEach(b => b.classList.remove('am-selected'));
        btn.classList.add('am-selected');
        selectedSize = btn.dataset.option1;
        const sizeVal = document.getElementById('am-size-val');
        if (sizeVal) sizeVal.textContent = selectedSize;

        /* 100cm premium notu */
        const premiumNote = document.getElementById('am-premium-note');
        if (premiumNote) {
          premiumNote.style.display = selectedSize && selectedSize.includes('100') ? 'flex' : 'none';
        }

        const variant = findVariant(selectedSize, selectedFrame);
        updateUI(variant);
      });
    });
  }

  /* ── QTY ── */
  function initQty() {
    const input = document.getElementById('am-qty-input');
    document.getElementById('am-qty-minus')?.addEventListener('click', () => {
      qty = Math.max(1, qty - 1);
      if (input) input.value = qty;
    });
    document.getElementById('am-qty-plus')?.addEventListener('click', () => {
      qty++;
      if (input) input.value = qty;
    });
    input?.addEventListener('change', () => {
      qty = Math.max(1, parseInt(input.value) || 1);
      input.value = qty;
    });
  }

  /* ── KALLES DRAWER ── */
  function openKallesDrawer() {
    const triggers = ['.js-mini-cart-toggle','[data-action="open-cart"]','#cart-icon-bubble','.cart-icon-bubble','[href="/cart"]'];
    for (const sel of triggers) {
      const el = document.querySelector(sel);
      if (el) { el.click(); return; }
    }
    window.location.href = '/cart';
  }

  /* ── SEPETE EKLE ── */
  function initAddToCart() {
    const btn = document.getElementById('am-add-to-cart');
    if (!btn) return;
    btn.addEventListener('click', () => {
      if (!selectedVariantId) return;
      const origHTML = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = 'Ekleniyor...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: selectedVariantId, quantity: qty })
      })
      .then(r => r.json())
      .then(() => { btn.disabled = false; btn.innerHTML = origHTML; openKallesDrawer(); })
      .catch(() => { btn.disabled = false; btn.innerHTML = origHTML; window.location.href = '/cart'; });
    });

    document.getElementById('am-sticky-atc')?.addEventListener('click', () => {
      if (!selectedVariantId) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: selectedVariantId, quantity: qty })
      }).then(() => openKallesDrawer()).catch(() => { window.location.href = '/cart'; });
    });
  }

  /* ── ŞARJLI APLİK KARTI ── */
  function initSconceCard() {
    const btn = document.getElementById('am-sconce-card-add');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const vid = window.__amSconceVariantId;
      if (!vid) return;
      const origHTML = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = 'Ekleniyor...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
      })
      .then(r => r.json())
      .then(() => { btn.disabled = false; btn.innerHTML = origHTML; openKallesDrawer(); })
      .catch(() => { btn.disabled = false; btn.innerHTML = origHTML; });
    });
  }

  /* ── HIZLI SATIN AL ── */
  function initBuyNow() {
    document.getElementById('am-buy-now')?.addEventListener('click', () => {
      if (!selectedVariantId) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: selectedVariantId, quantity: qty })
      }).then(() => { window.location.href = '/checkout'; }).catch(() => { window.location.href = '/cart'; });
    });
  }

  /* ── STICKY CTA ── */
  function initStickyCta() {
    const sticky     = document.getElementById('am-sticky-cta');
    const atcSection = document.getElementById('am-qty-cta-section');
    if (!sticky || !atcSection) return;
    const observer = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('am-visible', show);
      const wp = document.getElementById('am-wa-wrap');
      if (wp) wp.classList.toggle('am-wp-above-sticky', show);
    }, { threshold: 0 });
    observer.observe(atcSection);
  }

  /* ── ACCORDION ── */
  function initAccordion() {
    $$('.am-acc-trigger').forEach(trigger => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('.am-acc-item');
        const body = item?.querySelector('.am-acc-body');
        const isOpen = item?.classList.contains('am-open');
        $$('.am-acc-item.am-open').forEach(i => {
          i.classList.remove('am-open');
          const b = i.querySelector('.am-acc-body');
          if (b) b.style.maxHeight = '0';
        });
        if (!isOpen && body) {
          item.classList.add('am-open');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });
  }

  /* ── ÖLÇÜ REHBERİ MODAL ── */
  window.amOpenOlcuRehberi = function () {
    const modal = document.getElementById('am-olcu-modal');
    if (modal) { modal.style.display = 'flex'; document.body.style.overflow = 'hidden'; }
  };
  document.getElementById('am-modal-close')?.addEventListener('click', () => {
    const modal = document.getElementById('am-olcu-modal');
    if (modal) { modal.style.display = 'none'; document.body.style.overflow = ''; }
  });
  document.getElementById('am-olcu-modal')?.addEventListener('click', e => {
    if (e.target === document.getElementById('am-olcu-modal')) {
      document.getElementById('am-olcu-modal').style.display = 'none';
      document.body.style.overflow = '';
    }
  });
  document.getElementById('am-olcu-btn')?.addEventListener('click', () => {
    const acc = document.getElementById('am-acc-olcu');
    if (acc) {
      acc.querySelector('.am-acc-trigger')?.click();
      acc.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  /* ── TAKSİT — skeleton göster, PayTR gerçek değerleri dolduracak ── */
  function updateInstallments() {
    $$('.am-installment-amt').forEach(el => {
      el.textContent = '';
      el.classList.add('am-loading');
    });
  }

  /* ── PayTR'den gerçek taksit tutarları gelince skeleton'ı doldur ── */
  document.addEventListener('paytr:installments:ready', (e) => {
    const amounts = e.detail && e.detail.amounts;
    if (!amounts || !amounts.length) return;
    const amts = $$('.am-installment-amt');
    amounts.forEach((amt, i) => {
      if (!amts[i]) return;
      amts[i].classList.remove('am-loading');
      amts[i].textContent = amt;
    });
  });

  /* ── STOK UYARISI ── */
  function updateStockAlert(variant) {
    const el  = document.getElementById('am-stock-alert');
    const txt = document.getElementById('am-stock-text');
    if (!el || !txt) return;
    const pid = variants[0].product_id || 1;
    const seed = ((pid * 7 + 13) % 11) + 4;
    const days  = ((pid * 3 + 17) % 6) + 2;
    txt.textContent = 'Son ' + days + ' günde ' + seed + ' kişi bu tasarımı sipariş etti';
    el.style.display = 'flex';
  }

  /* ── BADGE GÜNCELLE ── */
  function updateBadge(variant) {
    const badgeEl = document.querySelector('.am-badge.am-badge-sale');
    if (!badgeEl) return;
    if (variant.compare_at_price > variant.price) {
      const disc = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
      badgeEl.textContent = '%' + disc + ' İNDİRİM';
      badgeEl.style.display = '';
    } else {
      badgeEl.style.display = 'none';
    }
  }

  /* ── JUDGE.ME FALLBACK ── */
  function initReviewFallback() {
    const fallback = document.querySelector('.am-review-link--fallback');
    if (!fallback) return;
    const badge = document.querySelector('.jdgm-preview-badge');
    if (!badge) return;
    const check = () => {
      if (badge.querySelector('.jdgm-prev-badge__rating, .jdgm--on, [class*="rating"]')) {
        fallback.style.display = 'none';
      }
    };
    new MutationObserver(check).observe(badge, { childList: true, subtree: true });
    setTimeout(check, 800);
  }

  /* ── CANLI SİNYAL ── */
  function initLiveSignal() {
    const el = document.getElementById('am-live-count');
    if (!el) return;
    const base = parseInt(el.textContent) || 24;
    setInterval(() => {
      const delta = Math.floor(Math.random() * 5) - 2;
      el.textContent = Math.max(8, base + delta);
    }, 7000);
  }

  /* ── BAŞLAT ── */
  document.addEventListener('DOMContentLoaded', () => {
    initGallery();
    initFrameSwatches();
    initSizeTiles();
    initQty();
    initAddToCart();
    initSconceCard();
    initBuyNow();
    initStickyCta();
    initAccordion();
    initLiveSignal();
    initReviewFallback();
    updateInstallments();
    updateStockAlert(variants[0]);

    /* İlk yüklemede 100cm seçiliyse premium notu göster */
    const premiumNote = document.getElementById('am-premium-note');
    if (premiumNote && selectedSize && selectedSize.includes('100')) {
      premiumNote.style.display = 'flex';
    }
  });

})();
